import { Box, Paper, Typography } from '@mui/material'
import React, { FC, useEffect } from 'react'
import { useDropzone } from 'react-dropzone'

interface Props {
  isDragAccept?: boolean
  isDragReject?: boolean
  isFocused?: boolean
}

const getColor = (props: Props) => {
  if (props.isDragAccept) {
    return '#00e676'
  }
  if (props.isDragReject) {
    return '#ff1744'
  }
  if (props.isFocused) {
    return '#2196f3'
  }
  return '#eeeeee'
}

interface StyledDropzoneProps {
  setFiles: React.Dispatch<React.SetStateAction<File[]>>
}

export const StyledDropzone: FC<StyledDropzoneProps> = ({ setFiles }) => {
  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    multiple: false,
    accept: {
      'image/*': [],
      'application/pdf': []
    }
  })

  useEffect(() => {
    setFiles(acceptedFiles)
  }, [acceptedFiles, setFiles])

  return (
    <Box className="container">
      <Paper
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          padding: 2,
          borderWidth: 2,
          borderRadius: 2,
          borderColor: getColor({ isFocused, isDragAccept, isDragReject }),
          borderStyle: 'dashed',
          backgroundColor: '#fafafa',
          color: '#898989',
          outline: 'none',
          transition: 'border 0.24s ease-in-out'
        }}
        {...getRootProps()}>
        <input {...getInputProps()} />
        {acceptedFiles.length === 1 ? (
          <Typography variant="body1">
            {acceptedFiles[0].name} - {acceptedFiles[0].size} bytes
          </Typography>
        ) : (
          <Typography variant="body1">
            Drag &apos;n&apos; drop some files here to upload, or click to
            select files
          </Typography>
        )}
      </Paper>
    </Box>
  )
}
